import React from 'react';
import NextFutureImage from 'next/image';
import { gql } from '@soundxyz/gql-string';
import { styled } from '@components-shared/src/stitches';
import { AccessibleLink } from '@components/main-components/link/AccessibleLink';
import type { FragmentType } from '@graphql/reactQuery';
import { getFragment } from '@graphql/reactQuery';
import { GoldenEggCoverBadgeFragmentDoc } from '@graphql/reactQuery';
import { webappUriPath } from '@utils/url';

/*#__PURE__*/ gql(/* GraphQL */ `
  fragment GoldenEggCoverBadge on Release {
    id
    goldenEggNft {
      id
      serialNumber
      owner {
        id
        username
        webappUri
      }
    }
  }
`);

export const GoldenEggCoverBadge = ({
  releaseFrag,
}: {
  releaseFrag: FragmentType<GoldenEggCoverBadgeFragmentDoc>;
}) => {
  const release = getFragment(GoldenEggCoverBadgeFragmentDoc, releaseFrag);

  const goldenEggNft = release.goldenEggNft;

  return (
    <Container>
      <NextFutureImage
        alt="golden egg image"
        src="/images/golden_egg_icon.png"
        width={42}
        height={42}
      />
      <GoldenEggWinnerDetails>
        {!!goldenEggNft ? (
          <>
            <AccessibleLink pathnameUri={webappUriPath(goldenEggNft.owner.webappUri)}>
              <Username>{goldenEggNft.owner.username}</Username>
            </AccessibleLink>
            <EditionNumber>Edition #{goldenEggNft.serialNumber}</EditionNumber>
          </>
        ) : (
          <NotRevealedLabel>Not Revealed</NotRevealedLabel>
        )}
      </GoldenEggWinnerDetails>
    </Container>
  );
};

const Container = styled('div', {
  display: 'flex',
  gap: 8,
  padding: '4px 20px 4px 6px',
  alignItems: 'center',
  background: 'rgba(255, 255, 255, 0.7)',
  backdropFilter: 'blur(9.78654px)',
  borderRadius: 75.0302,
});

const GoldenEggWinnerDetails = styled('div', {
  display: 'flex',
  flexDirection: 'column',
});

const Username = styled('p', {
  base: 'S',
  fontStyle: 'semibold',
  color: '$black',
});

const EditionNumber = styled('p', {
  base: 'XS',
  fontStyle: 'medium',
  color: '$black',
  opacity: 0.5,
});

const NotRevealedLabel = styled('p', {
  base: 'M',
  fontStyle: 'medium',
  color: '$black',
  opacity: 0.75,
});
